import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Avatar, Box, Grid } from '@mui/material';
import { Person, Flag } from '@mui/icons-material';
import MAXIMOGif from './MAXIMO.gif';
import './TeamsDashboard.css'; // For animations

const TeamCard = ({ teamName, members, teamColor, animate }) => {
  return (
    <Card
    className={animate ? 'card-animation' : ''}
      sx={{
        width: 300,
        backgroundColor: teamColor,
        borderRadius: '12px',
        padding: 2,
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
        position: 'relative',
        zIndex: 2,
      }}
    >
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" color="white" fontWeight="bold">
            {teamName}
          </Typography>
          <Typography
            variant="body2"
            color="white"
            sx={{
              backgroundColor: '#ffffff40',
              borderRadius: '50%',
              width: 24,
              height: 24,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontWeight: 'bold',
            }}
          >
            {members.length}
          </Typography>
        </Box>

        <Box mt={2}>
          {members.map((member, index) => (
            <Box
              key={index}
              display="flex"
              alignItems="center"
              my={1}
              sx={{
                backgroundColor: member.isChief ? '#876A03' : '#ffffff20', // Highlight chief in gold
                borderRadius: '8px',
                padding: '4px 8px',
              }}
            >
              <Avatar sx={{ bgcolor: member.isChief ? '#ffffff20' : '#ffffff20', marginRight: 1 }}>
                <Person />
              </Avatar>
              <Typography variant="body1" color="white" fontWeight={member.isChief ? 'bold' : 'normal'}>
                {member.name}
              </Typography>
              {member.isChief && (
                <Flag
                  sx={{
                    color: 'white',
                    marginLeft: 6,
                  }}
                />
              )}
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

const TeamsDashboard = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [animateCard, setAnimateCard] = useState(false);

  useEffect(() => {
    // Automatically start the gift opening animation
    setTimeout(() => {
      setIsOpen(true);
      setAnimateCard(true);
      setTimeout(() => setAnimateCard(false), 2000); // Stop heartbeat animation after 2 seconds
    }, 900); // Simulate "opening" the gift after 2 seconds
  }, []);
  const teams = [
    {
      teamName: 'Melemele',
      members: [
        { name: 'Lidia Cumbe', isChief: false },
        { name: 'Yanina Baduro', isChief: false },
        { name: 'Ulisses Tembe', isChief: false },
        { name: 'Cláudio Monteiro', isChief: false },
        { name: 'Albertina Mateus', isChief: false },
        { name: 'Ribeiro Mario', isChief: false },
        { name: 'Benilde Chilambe', isChief: false },
        { name: 'Adelina Muchanga', isChief: false },
        { name: 'Raimundo Zandamela', isChief: false },
        { name: 'Juma Nguenha', isChief: false },
        { name: 'York Massasse', isChief: false },
      ],
      teamColor: '#876A03',
    },
  ];

  return (
    <Grid
      container
      spacing={3}
      justifyContent="center"
      alignItems="center"
      sx={{
        height: '100vh',
        backgroundColor: '#E8F5E9',
        padding: 2,
        zIndex: 1,
      }}
    >
      <Box
        component="img"
        src={MAXIMOGif}
        alt="background gif"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
        }}
      />
   {isOpen &&
        teams.map((team, index) => (
          <Grid item key={index}>
            <TeamCard
              teamName={team.teamName}
              members={team.members}
              teamColor={team.teamColor}
              animate={animateCard}
            />
          </Grid>
        ))}
    </Grid>
  );
};

export default TeamsDashboard;
